import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useRuntimeConfig } from '#app'
import { getCartId } from '~/composables/checkout.js'
import { trackEvent } from '~/composables/trackEvent.js'

export const createPaypalCardButton = (paypalButton, cartParams, router, callback, type = 'cart', address = {}) => {
  let cart_id = ''
  const config = useRuntimeConfig()
  const apiBase = config.public.productBase
  const currency = config.public.currency
  const configStore = useConfigStore()
  paypal
    .Buttons({
      // style: {
      //   layout: 'horizontal',
      // },
      onError(err) {
        // ElMessage.error('Payment failed, please try again later')
      },

      createOrder: async function (data, actions) {
        if (typeof callback === 'function') {
          const res = await callback()
          cart_id = res.cart.id
          trackEvent('add_pay', {
            refer: configStore.crmRefer,
            channel: configStore.crmChannel,
            extraData: {},
          })
          return res.order.result.id
        } else {
          const res = await getCartId(cartParams)
          cart_id = res.cart.id
          trackEvent('add_pay', {
            refer: configStore.crmRefer,
            channel: configStore.crmChannel,
            extraData: {},
          })
          return res.order.result.id
        }
      },

      onApprove: function (data, actions) {
        if (!data.orderID) {
          throw new Error('orderid is not exisit')
        }
        let orderData = {
          paymentID: data.orderID,
          orderID: data.orderID,
          cartId: cart_id,
        }
        let paypalParams = {}
        let request_params = {}
        if (type == 'checkout') {
          paypalParams = {
            first_name: address.first_name,
            second_name: address.last_name,
            email: address.email,
            phone_full: address.phone,
            address: address.address[0],
            city: address.city,
            country: address.country,
            province: address.state,
            code: address.postcode,
          }
          request_params = {
            client_secret: data.orderID,
            id: data.orderID,
            orderData: orderData,
            data: data,
            refer: cartParams.refer,
            utm_source: cartParams.utm_source,
            utm_medium: cartParams.utm_medium,
            utm_campaign: cartParams.utm_campaign,
            utm_term: cartParams.utm_term,
            utm_id: cartParams.utm_id,
            params: paypalParams,
          }
        } else {
          request_params = {
            client_secret: data.orderID,
            id: data.orderID,
            orderData: orderData,
            data: data,
            refer: cartParams.refer,
            utm_source: cartParams.utm_source,
            utm_medium: cartParams.utm_medium,
            utm_campaign: cartParams.utm_campaign,
            utm_term: cartParams.utm_term,
            utm_id: cartParams.utm_id,
          }
        }
        const url = `${apiBase}/onebuy/order/status?currency=${currency}`

        return fetch(url, {
          method: 'post',
          body: JSON.stringify(request_params),
          headers: {
            'content-type': 'application/json',
          },
        })
          .then(function (res) {
            return res.json()
          })
          .then(function (res) {
            if (res.code == 200 || res.code == 201) {
              ElMessage.success('Payment successful')
              trackEvent('Purchase', {
                refer: '',
                channel: '',
                extraData: {
                  fbq: { order_id: res.order_id, value: res.order.grand_total, currency: res.order.base_currency_code }, // Facebook 可扩展数据
                  ttq: { order_id: res.order_id, value: res.order.grand_total, currency: res.order.base_currency_code }, // TikTok 可扩展数据
                },
              })
              router.push(`/success/${res.order_id}`)
            } else {
              throw new Error(res.error)
            }
          })
          .catch((error) => {
            crmTrack('paypal_error', configStore.crmRefer, configStore.crmChannel, error.message)
            ElMessage.error('Payment failed, please pay again')
            console.error('There was a problem with the fetch operation:', error)
          })
      },
    })
    .render(paypalButton)
}
